import React from 'react';
import ConfirmMailContent from '../ConfirmMailContent';

const ConfirmMail = () => (
  <div className="text-center">
    <ConfirmMailContent email="xyz@abc.com" />
  </div>
);

export default ConfirmMail;
